import { createContext, useContext } from 'react';

import type { GradingGridRow } from '@/components/common';
import type { OnFarmImplantFreshEmbryo } from '@/services/on-farm-implant';

export type FreshTabContextValue = {
  sessionId: string;
  readOnly: boolean;
  embryos: OnFarmImplantFreshEmbryo[];
  nextStrawNumber: string;
  setNextStrawNumber: (value: string) => void;
  gradingByMating: Record<string, GradingGridRow[]>;
  setMatingGrading: (matingKey: string, rows: GradingGridRow[]) => void;
};

export const FreshTabContext = createContext<FreshTabContextValue | null>(null);

export const useFreshTab = () => {
  const value = useContext(FreshTabContext);
  if (!value) {
    throw new Error('useFreshTab must be used within FreshTabContext');
  }
  return value;
};
